import React from 'react';
import { ArrowUpRight, ArrowDownRight } from 'lucide-react';

interface KpiStatCardProps {
    title: string;
    value: string | number;
    trend: string;
    trendType: 'up' | 'down';
}

const KpiStatCard: React.FC<KpiStatCardProps> = ({ title, value, trend, trendType }) => {
    const isUp = trendType === 'up';

    return (
        <div className="bg-[#0A0B0E] border border-[#1A1D24] rounded-xl p-5 flex flex-col justify-between shadow-lg h-[100px]">
            <h3 className="text-[11px] text-[#8B949E] font-mono tracking-wide mb-2">{title}</h3>

            <div className="flex justify-between items-end">
                <span className="text-[28px] leading-none font-bold text-white">{value}</span>

                <div className={`flex items-center gap-1 text-[11px] font-mono font-medium ${isUp ? 'text-[#39FF14]' : 'text-[#FF3333]'}`}>
                    {isUp ? (
                        <ArrowUpRight className="w-3.5 h-3.5 stroke-[3]" />
                    ) : (
                        <ArrowDownRight className="w-3.5 h-3.5 stroke-[3]" />
                    )}
                    {trend}
                </div>
            </div>
        </div>
    );
};

export default KpiStatCard;